import { Vector3 } from 'three';

import { FNode, outlineFromNode } from '@spazious/dollhouse-fsetup';
import { isPointInNavMesh, NavMeshQuery } from '@spazious/dollhouse-navmesh';

const _point = new Vector3();

export const validateNodesPlacement = (
  nodes: FNode[],
  navMeshQuery?: NavMeshQuery
): { valid: boolean; error?: string } => {
  if (!navMeshQuery) return { valid: true };

  let success = true;
  for (let node of nodes) {
    const corners = outlineFromNode(node);
    if (!corners.every((p) => isPointInNavMesh(_point.set(p[0], 0, p[1]), navMeshQuery))) {
      success = false;
      break;
    }
  }

  return { valid: success, error: success ? '' : 'Furnitures are placed out of the space' };
};
